import React, { Children, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// components
import { Table } from 'semantic-ui-react';
import DefaultButton from 'app/components/commons/button/DefaultButton';
// utils
import _ from 'lodash';
import { capitalize } from 'app/utils';

// consts
import { COLORS } from 'app/config/colors';
// assets
import plusIcon from 'assets/icons/button-icons/plus-icon-41a152.svg';
import plusIconHover from 'assets/icons/button-icons/plus-icon-ffffff.svg';
// stylesheet
import styles from './List.module.scss';

function List(props) {
  const onClickIncreaseListLimit = () => {
    props.onClickIncreaseList();
  };

  const buildCells = obj => {
    const cells = columns.map(column => {
      const { id, width, textAlign, property, headerTag, bodyNode, isLimitSize } = column;
      return {
        id,
        width,
        textAlign,
        headerTag,
        tagBody: property
          ? isLimitSize
            ? limitSize(capitalize(_.get(obj, property)))
            : _.get(obj, property)
          : null,
        bodyNode: bodyNode || null
      };
    });

    return cells;
  };

  const { rows, columns, children /* loading */ } = props;

  const limitSize = info => {
    if (info.length > 50) {
      return info.substr(0, 50) + '...';
    }
    return info;
  };

  return (
    <div className={styles.list}>
      <Table id='list-menu' className={styles.table}>
        <Table.Header>
          <Table.Row>
            {columns.map(column => {
              const { id, width, textAlign, headerTag } = column;
              return (
                <Table.HeaderCell key={id} width={width} style={{ textAlign }}>
                  {headerTag}
                </Table.HeaderCell>
              );
            })}
            {children && <Table.HeaderCell width={2} />}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {rows.map(row => {
            const { id } = row;
            const cells = buildCells(row);

            return (
              <Table.Row key={id}>
                {cells.map(cell => {
                  let { id, width, textAlign, tagBody, bodyNode } = cell;

                  let node = tagBody;

                  if (typeof bodyNode === 'function') {
                    bodyNode = bodyNode(row);
                  }

                  if (isValidElement(bodyNode)) {
                    const props = { row: row, entity: row };

                    if (bodyNode.props.onClick) {
                      props.onClick = e => bodyNode.props.onClick(e, row);
                    }

                    // node = cloneElement(bodyNode, { ...props }, tagBody);
                    node = Children.map(bodyNode, childLevelOne => {
                      if (isValidElement(childLevelOne)) {
                        if (childLevelOne.props.children) {
                          return Children.map(childLevelOne.props.children, child => {
                            if (isValidElement(child)) {
                              let children = child.props.children ? [...child.props.children] : [];
                              // let children = [...child.props.children];
                              return cloneElement(child, { ...props }, [...children]);
                            } else {
                              return cloneElement(childLevelOne, { ...props }, child);
                            }
                          });
                        } else {
                          return cloneElement(childLevelOne, { ...props }, tagBody);
                        }
                      }
                    });
                  }
                  return (
                    <Table.Cell key={id} width={width} style={{ textAlign }}>
                      {node}
                    </Table.Cell>
                  );
                })}
                {children && (
                  <Table.Cell textAlign='center' className={styles.popUpAlign} width={2}>
                    {Children.map(children, child => {
                      if (isValidElement(child)) {
                        return cloneElement(child, { row: row, entity: row });
                      }
                    })}
                  </Table.Cell>
                )}
              </Table.Row>
            );
          })}
          {
            <Table.Row>
              <Table.Cell colSpan='12'>
                <span className={styles.increaseButton}>
                  <DefaultButton
                    tag=''
                    size='medium'
                    backgroundColor={COLORS.WHITE_VARIANT}
                    backgroundColorHover={COLORS.ACCENTUATED_VARIANT}
                    icon={plusIcon}
                    iconHover={plusIconHover}
                    onClick={onClickIncreaseListLimit}
                  />
                </span>
              </Table.Cell>
            </Table.Row>
          }
        </Table.Body>
      </Table>
    </div>
  );
}

List.defaultProps = {
  loading: false,
  rows: {},
  columns: []
};

List.propTypes = {
  children: PropTypes.node,
  auth: PropTypes.object,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
      textAlign: PropTypes.string.isRequired,
      headerTag: PropTypes.string.isRequired,
      bodyNode: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
      property: PropTypes.string
    })
  ),
  rows: PropTypes.array,
  loading: PropTypes.bool,
  onClickIncreaseList: PropTypes.func
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(List);
